<template>
  <div class="register-container">
    <h1>用户注册</h1>
    <el-form 
      ref="registerForm" 
      :model="registerForm" 
      :rules="rules" 
      label-width="100px" 
      class="register-form"
    >
      <el-form-item label="用户名" prop="username">
        <el-input v-model="registerForm.username" placeholder="请输入用户名"></el-input>
      </el-form-item>
      
      <el-form-item label="邮箱" prop="email">
        <el-input v-model="registerForm.email" placeholder="请输入邮箱"></el-input>
      </el-form-item>
      
      <el-form-item label="密码" prop="password">
        <el-input 
          v-model="registerForm.password" 
          type="password" 
          placeholder="请输入密码"
          show-password
        ></el-input>
      </el-form-item>
      
      <el-form-item label="确认密码" prop="confirmPassword">
        <el-input 
          v-model="registerForm.confirmPassword" 
          type="password" 
          placeholder="请再次输入密码"
          show-password
        ></el-input>
      </el-form-item>
      
      <el-form-item label="姓名" prop="fullName">
        <el-input v-model="registerForm.fullName" placeholder="请输入真实姓名"></el-input>
      </el-form-item>
      
      <el-form-item label="手机号" prop="phone">
        <el-input v-model="registerForm.phone" placeholder="请输入手机号">
          <el-button 
            slot="append" 
            :disabled="isCountingDown" 
            @click="sendVerificationCode"
          >
            {{ countdownText }}
          </el-button>
        </el-input>
      </el-form-item>
      
      <el-form-item label="验证码" prop="verificationCode">
        <el-input 
          v-model="registerForm.verificationCode" 
          placeholder="请输入验证码"
        ></el-input>
      </el-form-item>
      
      <el-form-item>
        <el-button 
          type="primary" 
          @click="submitForm" 
          class="register-btn"
          :loading="loading"
        >
          立即注册
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

export default {
  name: 'RegisterPage',
  
  data() {
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.registerForm.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }

    const validatePhone = (rule, value, callback) => {
      const phoneReg = /^1[3-9]\d{9}$/
      if (!value) {
        callback(new Error('请输入手机号'))
      } else if (!phoneReg.test(value)) {
        callback(new Error('请输入正确的手机号'))
      } else {
        callback()
      }
    }

    return {
      registerForm: {
        username: '',
        email: '',
        password: '',
        confirmPassword: '',
        fullName: '',
        phone: '',
        verificationCode: ''
      },
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 3, max: 16, message: '长度在 3 到 16 个字符', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, validator: validatePass, trigger: 'blur' }
        ],
        fullName: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        phone: [
          { required: true, validator: validatePhone, trigger: 'blur' }
        ],
        verificationCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { len: 6, message: '验证码长度为6位', trigger: 'blur' }
        ]
      },
      loading: false,
      isCountingDown: false,
      countdown: 0
    }
  },
  computed: {
    countdownText() {
      return this.isCountingDown ? `${this.countdown}秒后重新获取` : '获取验证码'
    }
  },
  methods: {
    sendVerificationCode() {
      this.$refs.registerForm.validateField('phone', (valid) => {
        if (!valid) {
          this.isCountingDown = true
          this.countdown = 60
          
          // 模拟发送验证码请求
          console.log('发送验证码到:', this.registerForm.phone)
          this.$message.success('验证码已发送')
          
          const timer = setInterval(() => {
            this.countdown--
            if (this.countdown <= 0) {
              clearInterval(timer)
              this.isCountingDown = false
            }
          }, 1000)
        }
      })
    },
    submitForm() {
      this.$refs.registerForm.validate((valid) => {
        if (valid) {
          this.loading = true
          
          // 模拟注册请求
          setTimeout(() => {
            console.log('注册信息:', this.registerForm)
            this.$message.success('注册成功')
            this.loading = false
            
            // 这里可以跳转到登录页或其他页面
            this.$router.push('/')
          }, 1500)
        } else {
          console.log('表单验证失败')
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
.register-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #f5f5f5;
}

.register-form {
  width: 600px;
  padding: 30px;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.register-container h1 {
  text-align: center;
  margin-bottom: 30px;
  color: #333;
}

.register-btn {
  width: 100%;
  margin-top: 10px;
}
</style>
